export default {"src":"/_next/static/media/manufactureLogo1.4e513adf.svg","height":48,"width":150,"blurWidth":0,"blurHeight":0};